/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
    GET_PASSES_FOR_SALE = '[Passes] Get User Passes',
    GET_PASSES_FOR_SALE_SUCCESS = '[Passes] Get User Passes Success',
    GET_USER_PASSES = '[Passes] Get User Passes',
    GET_USER_PASSES_SUCCESS = '[Passes] Get User Passes Success',

    RELOAD_USER_PASS = '[Passes] Reload User Passes',

    GET_PASS_CART = '[Passes] Get Pass Cart',
    UPDATE_PASS_CART = '[Passes] Update Pass Cart',
    UPDATE_PASS_CART_SUCCESS = '[Passes] Update Pass Cart Success',
    CLEAR_PASS_CART = '[Passes] Clear Pass Cart'
}

export const getPassesForSale = createAction(
    ActionTypes.GET_PASSES_FOR_SALE,
    props<{ data: any }>()
);
export const getPassesForSaleSuccess = createAction(
    ActionTypes.GET_PASSES_FOR_SALE_SUCCESS,
    props<{ data: any }>()
);

export const getPassCart = createAction(
    ActionTypes.GET_PASS_CART,
    props<{ data: any }>()
);


export const updatePassCart = createAction(
    ActionTypes.UPDATE_PASS_CART,
    props<{ data: any }>()
);

export const updatePassCartSuccess = createAction(
    ActionTypes.UPDATE_PASS_CART_SUCCESS,
    props<{ data: any }>()
);

export const reloadUserPass = createAction(
    ActionTypes.RELOAD_USER_PASS
);

export const clearPassCart = createAction(
    ActionTypes.CLEAR_PASS_CART
);

